const API_URL = '/api/rfq';

class RfqService {
    async getAll() {
        const response = await fetch(API_URL, {
            headers: this.getHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch RFQs');
        return await response.json();
    }

    async getById(id) {
        const response = await fetch(API_URL + '/' + id, {
            headers: this.getHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch RFQ');
        return await response.json();
    }

    async create(rfqData) {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify(rfqData)
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to create RFQ');
        }
        return await response.json();
    }

    async update(id, rfqData) {
        const response = await fetch(API_URL + '/' + id, {
            method: 'PUT',
            headers: this.getHeaders(),
            body: JSON.stringify(rfqData)
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to update RFQ');
        }
        return await response.json();
    }

    async delete(id) {
        const response = await fetch(API_URL + '/' + id, {
            method: 'DELETE',
            headers: this.getHeaders()
        });
        if (!response.ok) throw new Error('Failed to delete RFQ');
        return await response.json();
    }

    async deleteMultiple(ids) {
        const response = await fetch(API_URL + '/batch-delete', {
            method: 'POST',
            headers: this.getHeaders(),
            body: JSON.stringify({ ids })
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to delete RFQs');
        }
        return await response.json();
    }

    getHeaders() {
        const token = localStorage.getItem('token');
        return {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': 'Bearer ' + token })
        };
    }
}

export default new RfqService();